import { createWsConnectThunks, WsPrefixes } from '@skynet/data-ws-core';
import type { WsAssistantState } from './slice';

export type AssistantWsState = { wsAssistant: WsAssistantState };

const { wsLogout, wsDisconnect, subscribeWsData } = createWsConnectThunks({
  sliceKey: 'wsAssistant',
  prefix: WsPrefixes.assistantPrefix,
  logoutCommand: 'Logout',
  disconnectCommand: 'Disconnect',
});

export {
  wsLogout as wsAssistantLogout,
  wsDisconnect as wsAssistantDisconnect,
  subscribeWsData as subscribeWsAssistantData,
};
